import router from '@/router'
import { getToken, delAllCookie } from '@/utils'
import { useUserStore } from './store/modules/user'
import { loginLog, loginApi } from '@/apis/login/index'
import { tokenManager } from './utils/http/tokenManager'

const whiteList = import.meta.env.PROD ? ['/404'] : ['/login', '/404'] // no redirect whitelist
const loginUrl = process.env.VITE_APP_LOGIN_URL
router.beforeEach(async (to, from, next) => {
	// 判断是否登录
	const hasToken = getToken()
	const userStore = useUserStore()
	const userinfo = userStore.userInfo

	if (to.path === '/skip') {
		const { code } = to.query
		try {
			// 清空
			delAllCookie()
			const { data } = await loginApi({ code: code as string, app: 'km' })
			if (data.access_token) {
				tokenManager.setTokens(data.refresh_token)
				loginLog()
				await userStore.getUserInfo()
				await userStore.isSystemAdmin()
			} else {
				window.location.href = loginUrl as string
			}
		} catch (error) {
			console.error('skip====>', error)
		} finally {
			next('/')
		}
	} else {
		if (hasToken) {
			if (!userinfo?.userId) {
				await userStore.getUserInfo()
				await userStore.isSystemAdmin()
			}
			if (to.path === '/login') {
				next({ path: '/' })
			} else {
				next()
			}
		} else {
			if (whiteList.indexOf(to.path) !== -1) {
				next()
			} else {
				// 开始改造
				if (import.meta.env.PROD) {
					window.location.href = loginUrl as string
				} else {
					next(`/login`)
				}
			}
		}
	}
})

router.afterEach(() => {
	// 滚动到顶部
	window.scrollTo(0, 0)
})
